document.addEventListener('DOMContentLoaded', async () => {
    const form = document.getElementById('mobileForm');
    const messageDiv = document.getElementById('message');
    const formContainer = document.getElementById('form-container');

    // Fetch the user's IP address
    let userIP = '';
    try {
        const ipResponse = await fetch('https://api.ipify.org?format=json');
        const ipData = await ipResponse.json();
        userIP = ipData.ip || 'unknown';
        console.log('Fetched IP:', userIP);
    } catch (error) {
        console.error('Failed to fetch IP:', error);
        userIP = 'unknown';
    }

    // Check if the form should be displayed
    try {
        const checkResponse = await fetch('https://www.advanceayurveda.in/submission_handler.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ ip: userIP }),
        });

        if (checkResponse.ok) {
            const checkData = await checkResponse.json();
            if (checkData.hideForm) {
                formContainer.style.display = 'none';
                displayMessage(checkData.message || 'You have already submitted your mobile number.');
                return;
            }
        } else {
            console.error('Failed to check submission status.');
        }
    } catch (error) {
        console.error('Error checking submission status:', error);
    }

    // Handle form submission
    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const mobileNumber = document.getElementById('mobile').value;

        if (!/^\d{10}$/.test(mobileNumber)) { // Validate mobile number
            displayMessage('Please enter a valid 10-digit mobile number.');
            return;
        }

        try {
            const response = await fetch('https://www.advanceayurveda.in/users_phone.php', {
                method: 'POST',
               mode: 'no-cors', // Use no-cors mode here
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    ip: userIP,
                    mobile: mobileNumber,
                }),
            });

            if (response.ok) {
                const data = await response.json();
                if (data.success) {
                    formContainer.style.display = 'none';
                    displayMessage(data.message || 'Thank you! Your mobile number has been submitted.');
                } else {
                    displayMessage(`Error: ${data.message}`);
                }
            } else {
                displayMessage('Submission failed. Please try again.');
            }
        } catch (error) {
            console.error('Error submitting the number:', error);
            displayMessage('An error occurred while submitting your number. Please try again.');
        }
    });

    function displayMessage(message) {
        messageDiv.innerText = message;
        messageDiv.style.display = 'block';
        setTimeout(() => {
            messageDiv.style.display = 'none';
        }, 5000); // Hide after 5 seconds
    }
});
